// TotalInventoryNearExpiry Getters

export const getTotalInventoryNearExpiryList = state => {
  return state.totalInventoryNearExpiryList
}

export const getTotalInventoryNearExpiryCount = state => {
  return state.totalInventoryNearExpiryCount
}
